import "./../App.css";
import "./../AppMobile.css";

import React from "react";
import { hideProcess, setLocaleApp, showProcess } from "./../utils/util";

import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import authenticateService from "../services/authenticateService";
import accountService from "../services/accountService";
import Terms from "./terms";
import { Dialog } from "primereact/dialog";
import { InputOtp } from "primereact/inputotp";
import { Dropdown } from "primereact/dropdown";
import { InputMask } from "primereact/inputmask";
import userService from "../services/userService";
import ReCAPTCHA from "react-google-recaptcha";

export default class Login extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showPassword: false,
            showToken: false,
        };
    }

    componentDidMount() {
        setLocaleApp();
    }

    login = async (e) => {
        e.preventDefault();

        try {
            showProcess();

            if (!this.state.captcha) {
                alert("Por favor, complete o reCAPTCHA.");
                hideProcess();
                return;
            }

            var authRequest = {
                username: this.state.user,
                password: this.state.password,
                version: "1.0.0",
                captcha: this.state.captcha,
            };

            var response = await authenticateService.login(authRequest);

            if (response.status === 200) {
                if (response.data.status == "registration update required") {
                    this.setState({
                        showRegistrationUpdate: true,
                        tokenJwt: response.data.token,
                    });
                } else {
                    this.setState({ showToken: true });
                }
            } else {
                alert("Usuário ou senha inválidos.");
            }
        } catch (ex) {
            if (ex.response !== undefined) {
                alert(ex.response.data);
            } else {
                alert(ex);
            }
        }

        hideProcess();
    };

    confirmToken = async () => {
        try {
            showProcess();

            var authRequest = {
                username: this.state.user,
                password: this.state.password,
                version: "1.0.0",
                token2fa: this.state.token,
            };

            var response = await authenticateService.login(authRequest);

            if (response.status === 200) {
                await localStorage.setItem("authorization", response.data.tokenJwt);
                await localStorage.setItem("user", JSON.stringify(response.data));

                response = await accountService.getBalance();

                if (response.status === 200) {
                    await localStorage.setItem("balance", JSON.stringify(response.data));
                }

                window.location.href = "/";
            } else {
                alert("Token inválido.");
            }
        } catch (ex) {
            if (ex.response !== undefined) {
                alert(ex.response.data);
            } else {
                alert(ex);
            }
        }

        hideProcess();
    };

    validateCPF(cpf) {
        cpf = cpf.replace(/[^\d]+/g, "");
        if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

        let soma = 0;
        for (let i = 0; i < 9; i++) {
            soma += parseInt(cpf.charAt(i)) * (10 - i);
        }
        let resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        if (resto !== parseInt(cpf.charAt(9))) return false;

        soma = 0;
        for (let i = 0; i < 10; i++) {
            soma += parseInt(cpf.charAt(i)) * (11 - i);
        }
        resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        return resto === parseInt(cpf.charAt(10));
    }

    validateCNPJ(cnpj) {
        cnpj = cnpj.replace(/[^\d]+/g, "");
        if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false;

        let tamanho = cnpj.length - 2;
        let numeros = cnpj.substring(0, tamanho);
        let digitos = cnpj.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;

        for (let i = tamanho; i >= 1; i--) {
            soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
            if (pos < 2) pos = 9;
        }

        let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado !== parseInt(digitos.charAt(0))) return false;

        tamanho++;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;

        for (let i = tamanho; i >= 1; i--) {
            soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
            if (pos < 2) pos = 9;
        }

        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        return resultado === parseInt(digitos.charAt(1));
    }

    validateDocumento(valor) {
        const doc = valor.replace(/[^\d]+/g, "");
        if (doc.length === 11) {
            return this.validateCPF(doc);
        } else if (doc.length === 14) {
            return this.validateCNPJ(doc);
        } else {
            return false;
        }
    }

    confirmUpdateRegister = async () => {
        try {
            showProcess();

            var response = await userService.updateRegister(
                this.state.tokenJwt,
                this.state.token,
                this.state.document.replaceAll(".", "").replaceAll("/", "").replaceAll("-", ""),
                this.state.phone
                    .replaceAll("(", "")
                    .replaceAll(")", "")
                    .replaceAll(" ", "")
                    .replaceAll("-", "")
            );

            if (response.status === 200) {
                await localStorage.setItem("authorization", response.data.tokenJwt);
                await localStorage.setItem("user", JSON.stringify(response.data));

                window.location.href = "/";
            }
        } catch (e) {
            alert(e.response.data);
        }

        hideProcess();
    };

    updateRegister = async (event) => {
        event.preventDefault();

        if (!this.validateDocumento(this.state.document)) {
            if ((this.state.type = "J")) {
                alert("CNPJ INVÁLIDO.");
            } else {
                alert("CPF INVÁLIDO.");
            }

            return;
        }

        try {
            showProcess();

            const response = await userService.generateToken(
                this.state.tokenJwt,
                this.state.phone
                    .replaceAll("(", "")
                    .replaceAll(")", "")
                    .replaceAll(" ", "")
                    .replaceAll("-", "")
            );

            if (response.status === 200) {
                this.setState({ showTokenUpdateRegister: true });
            }
        } catch (e) {
            alert(this.responsecodes[e.response.data]);
        }

        hideProcess();
    };

    handleForgotPassword = async (event) => {
        event.preventDefault();

        if (!this.state.forgotPasswordEmail) {
            alert("Por favor, informe seu email.");
            return;
        }

        try {
            showProcess();

            // Aqui você precisará chamar um serviço de recuperação de senha
            // Por exemplo: await activateService.requestPasswordReset(this.state.forgotPasswordUser, this.state.forgotPasswordEmail);

            await userService.requestPasswordReset(this.state.forgotPasswordEmail)
            
            alert("Um link de recuperação de senha foi enviado para o seu email.");
            this.setState({ showForgotPassword: false, forgotPasswordUser: "", forgotPasswordEmail: "" });
        } catch (e) {
            alert("Erro ao processar sua solicitação. Tente novamente.");
        }

        hideProcess();
    };

    render() {
        return (
            <div className="content-login" style={{padding: "0px 100px"}} >
                <form onSubmit={(e) => this.login(e)}>
                    <div style={{ marginTop: "25px", display: "flex", flexDirection: "column", gap: "15px", textAlign: "center", alignItems: "center" }}>
                        <InputText
                            required
                            placeholder="CPF/CNPJ"
                            style={{width: "300px", padding: "20px", borderRadius: "20px", border: "1px solid #ccc"}}
                            value={this.state.user}
                            onChange={(e) => this.setState({ user: e.target.value })}
                        />
                    
                        <Password
                            required
                            toggleMask
                            placeholder="Senha" 
                            inputStyle={{width: "300px", padding: "20px", borderRadius: "20px", border: "1px solid #ccc"}}
                            value={this.state.password}
                            onChange={(e) => this.setState({ password: e.target.value })}
                            feedback={false}
                        />
                    </div>

                    <label
                        id="check-terms"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            marginBottom: "15px",
                            marginTop: "15px",
                        }}
                    >
                        <input type="checkbox" required />
                        <span style={{ fontSize: "12px", fontSize: "12px", color: "var(--unnamed-color-411172)",
                                fontWeight: "500", }}>
                            Ao marcar este campo você está concordando
                            <br /> com os nossos{" "}
                            <a href="#" onClick={() => this.setState({ showTerms: true })}>
                                termos de uso
                            </a>
                            .
                        </span>
                    </label>

                    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                        <ReCAPTCHA
                            sitekey="6LeME4UsAAAAADCIJ2oCJE7TWVQ-KhNqVgdSaQq6"
                            onChange={(value) => this.setState({ captcha: value })}
                        />
                    </div>

                    <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "15px" }}>
                        <button id="button-entrar" type="submit" style={{backgroundColor: "var(--unnamed-color-411172)", color: "#fff", border: "none", borderRadius: "20px", padding: "10px 40px", cursor: "pointer", fontSize: "15px", fontWeight: "600"}}>
                            Entrar
                        </button>
                    </div>

                    

                    <div style={{textAlign: "left", marginBottom: "15px", marginTop: "15px"}}>
                        <a
                            href={`https://api.whatsapp.com/send/?phone=5511942505855&text=Ol%C3%A1%2C+gostaria+de++alterar+minha+senha&type=phone_number&app_absent=0`}
                            style={{
                                background: "none",
                                border: "none",
                                color: "var(--unnamed-color-411172)",
                                cursor: "pointer",
                                textDecoration: "underline",
                                fontSize: "12px",
                                fontWeight: "500",
                                padding: "0"
                            }}
                        >
                            Esqueci minha senha
                        </a>
                    </div>

                    <div id="create-account">
                        <label style={{
                                background: "none",
                                border: "none",
                                color: "var(--unnamed-color-411172)",
                                cursor: "pointer",
                                fontSize: "12px",
                                fontWeight: "500",
                                padding: "0"
                            }}>
                            Não tem uma conta? <br/> <a href="/register" style={{fontSize: "12px",}}>Criar conta</a>
                        </label>
                    </div>
                </form>

                {/* Modal simples para exibir os termos */}
                {this.state.showTerms && (
                    <Terms onHide={() => this.setState({ showTerms: false })} />
                )}

                {this.state.showToken && (
                    <Dialog visible={true} onHide={() => this.setState({ showToken: false })}>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                flexDirection: "column",
                            }}
                        >
                            <div style={{ textAlign: "center" }}>
                                <label>
                                    Enviamos um código de confirmação seu telefone.
                                    <br />
                                    Por favor informe-o.
                                </label>
                            </div>
                            <div style={{ marginTop: "25px" }}>
                                <InputOtp
                                    value={this.state.token}
                                    length={6}
                                    onChange={(e) => this.setState({ token: e.value })}
                                />
                            </div>
                            <div
                                style={{
                                    width: "100%",
                                    textAlign: "center",
                                    marginTop: "25px",
                                }}
                            >
                                <button
                                    style={{
                                        width: window.innerWidth < 768 ? "100%" : "80%",
                                        padding: "15px",
                                        fontSize: window.innerWidth < 768 ? "18px" : "20px",
                                        color: "#ffffff",
                                        backgroundColor: "var(--unnamed-color-411172)",
                                        borderRadius: "30px",
                                    }}
                                    onClick={() => this.confirmToken()}
                                >
                                    Confirmar
                                </button>
                            </div>
                        </div>
                    </Dialog>
                )}

                {this.state.showTokenUpdateRegister && (
                    <Dialog
                        visible={true}
                        onHide={() => this.setState({ showTokenUpdateRegister: false })}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                flexDirection: "column",
                            }}
                        >
                            <div style={{ textAlign: "center" }}>
                                <label>
                                    Enviamos um código de confirmação seu telefone.
                                    <br />
                                    Por favor informe-o.
                                </label>
                            </div>
                            <div style={{ marginTop: "25px" }}>
                                <InputOtp
                                    value={this.state.token}
                                    length={6}
                                    onChange={(e) => this.setState({ token: e.value })}
                                />
                            </div>
                            <div
                                style={{
                                    width: "100%",
                                    textAlign: "center",
                                    marginTop: "25px",
                                }}
                            >
                                <button
                                    style={{
                                        width: window.innerWidth < 768 ? "100%" : "80%",
                                        padding: "15px",
                                        fontSize: window.innerWidth < 768 ? "18px" : "20px",
                                        color: "#ffffff",
                                        backgroundColor: "var(--unnamed-color-411172)",
                                        borderRadius: "30px",
                                    }}
                                    onClick={() => this.confirmUpdateRegister()}
                                >
                                    Confirmar
                                </button>
                            </div>
                        </div>
                    </Dialog>
                )}

                {this.state.showRegistrationUpdate && (
                    <Dialog
                        visible={true}
                        onHide={() => this.setState({ showRegistrationUpdate: false })}
                    >
                        <form onSubmit={(e) => this.updateRegister(e)}>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    flexDirection: "column",
                                }}
                            >
                                <div style={{ textAlign: "center" }}>
                                    <label>Atualize os seus cadastro.</label>
                                </div>

                                {/** Pessoa */}
                                <span
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "15px",
                                        marginTop: "20px",
                                    }}
                                >
                                    <span
                                        style={{
                                            color: "var(--unnamed-color-411172)",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Pessoa
                                    </span>
                                    <Dropdown
                                        options={[
                                            { key: "F", label: "Física" },
                                            { key: "J", label: "Jurídica" },
                                        ]}
                                        value={this.state.type}
                                        optionLabel="label"
                                        optionValue="key"
                                        onChange={(e) => this.setState({ type: e.value })}
                                        style={{ width: "300px" }}
                                    />
                                </span>
                                {/** CPF / CNPJ */}
                                <span
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "15px",
                                        marginTop: "20px",
                                    }}
                                >
                                    <span
                                        style={{
                                            color: "var(--unnamed-color-411172)",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        {this.state.type === "J" ? "CNPJ" : "CPF"}
                                    </span>
                                    <InputMask
                                        required
                                        mask={
                                            this.state.type === "J"
                                                ? "99.999.999/9999-99"
                                                : "999.999.999-99"
                                        }
                                        value={this.state.document}
                                        onChange={(e) =>
                                            this.setState({ document: e.target.value })
                                        }
                                        style={{ width: "300px" }}
                                    />
                                </span>

                                {/** Telefone */}
                                <span
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "15px",
                                        marginTop: "20px",
                                    }}
                                >
                                    <span
                                        style={{
                                            color: "var(--unnamed-color-411172)",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Telefone
                                    </span>
                                    <InputMask
                                        required
                                        mask="(99) 99999-9999"
                                        value={this.state.phone}
                                        onChange={(e) => this.setState({ phone: e.target.value })}
                                        style={{ width: "300px" }}
                                    />
                                </span>

                                <button
                                    style={{
                                        width: window.innerWidth < 768 ? "100%" : "80%",
                                        padding: "10px",
                                        marginTop: "20px",
                                        fontSize: window.innerWidth < 768 ? "18px" : "20px",
                                        color: "#ffffff",
                                        backgroundColor: "var(--unnamed-color-411172)",
                                        borderRadius: "30px",
                                    }}
                                    type="submit"
                                >
                                    Confirmar
                                </button>
                            </div>
                        </form>
                    </Dialog>
                )}

                {this.state.showForgotPassword && (
                    <Dialog
                        visible={true}
                        onHide={() => this.setState({ showForgotPassword: false })}
                        header="Recuperar Senha"
                    >
                        <form onSubmit={(e) => this.handleForgotPassword(e)}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                flexDirection: "column",
                            }}
                        >
                            <div className="app-field" style={{width: "100%", marginTop: "15px"}}>
                                <span>Informe seu EMAIL</span>
                                <InputText
                                    required
                                    type="email"
                                    value={this.state.forgotPasswordEmail}
                                    onChange={(e) => this.setState({ forgotPasswordEmail: e.target.value })}
                                    style={{width: "100%"}}
                                />
                            </div>
                            <div
                                style={{
                                    width: "100%",
                                    textAlign: "center",
                                    marginTop: "25px",
                                }}
                            >
                                <button
                                    style={{
                                        width: "80%",
                                        padding: "15px",
                                        fontSize: "16px",
                                        color: "var(--app-color-ffffff)",
                                        backgroundColor: "var(--app-color-primary)",
                                        borderRadius: "30px",
                                    }}
                                    className="app-button-size-01"
                                    type="submit"
                                >
                                    Enviar
                                </button>
                            </div>
                        </form>
                    </Dialog>
                )}
            </div>
        );
    }
}
